import React from "react";
import * as Styled from "./MobileAppStyled";
import AppDownloadButton from "../buttons/appDownloadButton/AppDownloadButton";
import QrCodeButton from "../buttons/qrCodeButton/QrCodeButton";

const MobileApp = () => {
    return (
        <React.Fragment>
            <Styled.MobileAppWrapper id={'mobile-app'}>
                <Styled.MobileAppRow>
                    <Styled.MobileAppTitle>
                        Mobil Uygulama
                    </Styled.MobileAppTitle>
                    <Styled.MobileAppText>
                        <p>
                            Mutluluk şimdi parmaklarınızın ucunda! Her an her yerden hesabınıza ulaşabilmek için Pembe
                            Panjur uygulamasını hemen indirin.
                        </p>
                    </Styled.MobileAppText>
                </Styled.MobileAppRow>
                <Styled.MobileAppRow>
                    <div className="store-and-qr-section">
                        <div className="store">
                            <AppDownloadButton storeName={'appStore'} url={'https://apps.apple.com/tr/app/pembe-panjur-evlilik-tan%C4%B1%C5%9Fma/id708825011?l=tr'} title={'Pembe Panjur App Store'}/>
                            <AppDownloadButton storeName={'playStore'} url={'https://play.google.com/store/apps/details?id=com.pembepanjur&hl=tr&gl=US'} title={'Pembe Panjur Google Play'}/>
                        </div>
                        <div className="qr">
                            <div className="qr-background-gradient">
                                <QrCodeButton url={'www.pembepanjur.com'}/>
                            </div>
                        </div>
                    </div>
                </Styled.MobileAppRow>
            </Styled.MobileAppWrapper>
        </React.Fragment>
    )
}

export default MobileApp;
